import { fmtG } from '../../utils/format';
import { MetricCard } from './MetricCard';
interface Props {
  value: number;
  colorClass?: string;
  className?: string;
  label?: string;
}
export function GnarrInfluencedCard({
  value,
  colorClass = 'c-gold',
  className,
  label = 'GNARR (DX) Influenced'
}: Props) {
  return <MetricCard label={label} value={fmtG(value)} sub="total opp GNARR (created qtr)" colorClass={colorClass} className={className} data-id="element-1293" data-mp="9kijonwf6t0a" />;
}